import React, { useEffect, useState } from "react";
import { api, fmtNum } from "@finance/lib/api";

export function ApTieout({ sid }) {
  const [d, setD] = useState(null);
  useEffect(() => { setD(null); api.get(`/suppliers/${sid}/ap-tieout`).then((r) => setD(r.data)).catch(() => {}); }, [sid]);
  if (!d) return null;
  return (
    <div className={`rounded-sm border px-3 py-2 text-xs ${d.ok ? "border-emerald-200 bg-emerald-50 text-emerald-800" : "border-amber-300 bg-amber-50 text-amber-800"}`} data-testid="supplier-ap-tieout">
      <b data-testid="supplier-ap-tieout-status">{d.ok ? "\u2713 AP ties out" : "\u26a0 AP does not tie out"}</b>
      <div>Statement {d.currency} {fmtNum(d.statement_balance)} \u00b7 GL 2000 TZS {fmtNum(d.gl_2000)} \u2212 GL 1470 TZS {fmtNum(d.gl_1470)} = TZS {fmtNum(d.gl_net)}{!d.ok && ` \u00b7 diff ${fmtNum(d.difference)}`}</div>
    </div>
  );
}
